import type { FaireProductEntity } from "../../entity_types/product";

export const p_8ppgrgz9j8: FaireProductEntity = {
  token: "p_8ppgrgz9j8",
  type: "product",
  name: "San Francisco Enamel Pins",
  brandToken: "b_c5lwttyyt1",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/89667ff22959f70072331f711a24331b9095ccb27f88dd3e4d8988d265d7be48.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a2083464c5b0004a5c92a978f65da468d4519a62d610cdd67b16a24c99f19742.jpeg",
    "https://cdn.faire.com/fastly/4a950881840f301ea3833e8dbaaa55e78ba3ce7009358c686dcdf9838a81802c.jpeg",
    "https://cdn.faire.com/fastly/c8ce57fd59a00cc4d1bec1bc45b9667c03aa1eac11fcd99bf694c0f8fc17334c.jpeg",
  ],
  priceDollars: 6.93,
  description:
    "Remember your San Francisco memories with these enamel pins. You can carry them on your favorite accessories!Golden Gate Twins\n\n1. Golden Gate Twins\nPin size: 1.5x1.1”\nPackage size: 3”x3”\nMetal color: Gold\n\n2. California Bear\nPin size: 0.9”x1.3”\nPackage size: 3”x3”\nMetal color: Gold\n\n3. Cable Car\nPin size: 1.3”x1”\nPackage size: 3”x3”\nMetal color: Gold\n\n4. Sea Lions & Crab\nPin size: 1.5”x0.95\nPackage size: 3”x3”\nMetal color: Gold",
  tags: [],
  msrpDollars: 13.86,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:57.924Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
